import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { BaseService } from '../base/base.service';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseImportService extends BaseService {
  protected constructor(
    protected baseRoute: string,
    protected filename: string,
    protected httpService: HttpService,
  ) {
    super(baseRoute, httpService);
  }

  export(): Observable<any> {
    return this.httpService
      .getForText(this.apiUrl)
      .pipe(tap((data: string) => this.downloadExportFile(data, this.filename)));
  }

  exportTemplateAndData(): Observable<any> {
    return this.httpService
      .getForText(`${this.apiUrl}/ExportTemplateAndData`)
      .pipe(tap((data: string) => this.downloadExportFile(data, this.filename)));
  }

  import(file: any): Observable<any> {
    const formData = this.getFormData(file);
    return this.httpService.postForText(this.apiUrl, formData);
  }

  public getFormData(file: any) {
    const formData = new FormData();
    formData.append('import', new Blob([file], { type: 'text/csv' }), file.name);
    return formData;
  }

  public downloadExportFile(data: string, fileName: string) {
    {
      const blob = new Blob([data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${fileName}.csv`;
      link.click();
    }
  }
}
